import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../../../Buttons/PlainButtonOrLink';
import ActionBarItemContentWrapper from '../ActionBarItemContentWrapper';
import s from './ActionBarLink.scss';
/** A link for our `ActionBar`. Will render a `span` instead of an anchor tag if `disabled` is passed  */
// TODO: Consolidate this and ActionBarButton into the same component? We should do this if we're able to eliminate the
// `<span>` branch here.
var ActionBarLink = function (_a) {
    var disabled = _a.disabled, className = _a.className, dataHook = _a.dataHook, children = _a.children, rest = __rest(_a, ["disabled", "className", "dataHook", "children"]);
    if (disabled) {
        return (React.createElement("span", { className: c(s['root'], className), "data-hook": dataHook },
            React.createElement(ActionBarItemContentWrapper, null, children)));
    }
    return (React.createElement(PlainButtonOrLink, __assign({}, rest, { "data-hook": dataHook, className: c(s['root'], className) }),
        React.createElement(ActionBarItemContentWrapper, null, children)));
};
ActionBarLink.displayName = 'ActionBarLink';
export default ActionBarLink;
//# sourceMappingURL=ActionBarLink.js.map